import React from 'react';
import styled, { css } from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import Preview from 'gatsby-theme-vehicles/src/components/preview';
import 'swiper/css'; // eslint-disable-line import/no-unresolved
import 'swiper/css/navigation'; // eslint-disable-line import/no-unresolved
import { A11y } from 'swiper/modules'; // eslint-disable-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react'; // eslint-disable-line import/no-unresolved

const MD = '768';

const SectionPreviews = ({
  className,
  vehicles = null,
  limit = 4,
  layout = null,
  breakpoint = MD,
  vdp,
}) => {
  const { vehicles: { nodes } } = useStaticQuery(graphql`
    query ACMStrapi4VehiclesPreviewsWithoutExclude {
      vehicles: allStrapiVehicle(
        limit: 4,
        filter: { isSold: { ne: true }, excludeFromPublic: { ne: true } },
        sort: { createdAt: DESC },
      ) {
        nodes {
          ...VehiclePreview
        }
      }
    }
  `);

  return (
    <div className={className}>
      <ShowAfterBreakpoint
        layout={layout}
        breakpoint={breakpoint}
        limit={limit}
      >
        {(vehicles || nodes).slice(0, limit).map((vehicle) => (
          <Preview
            key={vehicle.id}
            vehicle={vehicle}
            layout={layout}
            vdp={vdp}
            disableLinkOnSold
          />
        ))}
      </ShowAfterBreakpoint>

      <HideAfterBreakpoint breakpoint={breakpoint}>
        <SwiperWrapper breakpoint={breakpoint}>
          <Swiper
            modules={[A11y]}
            watchOverflow
            css="position: relative; margin-bottom: 1rem;"
            slidesPerView={1.3}
            spaceBetween={15}
            breakpoints={{
              [MD]: {
                slidesPerView: 2.3,
                spaceBetween: 15,
                centeredSlides: false,
              },
            }}
          >
            {(vehicles || nodes).slice(0, limit).map((vehicle) => (
              <SwiperSlide key={vehicle.id}>
                <Preview
                  vehicle={vehicle}
                  layout="column"
                  vdp={vdp}
                  disableLinkOnSold
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </SwiperWrapper>
      </HideAfterBreakpoint>
    </div>
  );
};

const SwiperWrapper = styled.div`
  margin-right: -${({ theme }) => theme.grid.containerGap};

  @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
    margin-left: 0;
    margin-right: 0;
  }
  .swiper-button-prev {
    left: 0rem;
  }
  .swiper-button-next {
    right: 0rem;
  }
  [class^="swiper-button-"] {
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    padding: .5rem;
    visibility: hidden;

    @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
      visibility: visible;
    }

    &:after {
      font-size: 1rem;
      @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
        font-size: 1.5rem;
      }
    }

    &.swiper-button-disabled {
      display: none;
    }
  }
`;

const HideAfterBreakpoint = styled.div`
  @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
    display: none;
  }
`;

const ShowAfterBreakpoint = styled.div`
  display: none;

  @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
    display: grid;
    grid-auto-rows: auto;
    grid-gap: ${({ theme }) => theme.grid.columnGap};

    ${({ layout }) => layout === 'row' && css`
      grid-template-columns: 1fr;
    `}

    ${({ layout }) => layout === 'column' && css`
      grid-template-columns: repeat(${({ limit }) => limit || '4'}, 1fr);
    `}
  }
`;

export default styled(SectionPreviews)`
  width: 100%;
`;
